import React from 'react';

import JobsListPage from '../../../js/pages/JobsListPage';
import security from '../../../js/pages/JobsListPage/securityJobs';

const Page = () => <JobsListPage role={security} />;

export default Page;
